import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { API_URLS } from '../global';
import { isDevMode } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { AnToastService } from '@autonation/dt-an-components-lib/an-toast';
import { CookieService } from 'ngx-cookie';
import { FormInfoService } from './form-info.service';

@Injectable({
  providedIn: 'root',
})
export class VehicleDetailsService {
  constructor(
    private http: HttpClient,
    private formInfoService: FormInfoService,
    private _toastService: AnToastService,
  ) {}
  public favVehicleDetails = new BehaviorSubject([]);
  getVehicleDetails(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    const url = `${API_URLS.Get_VehicleInfo_API_URL}`;
    let params = new HttpParams();
    params = params.append('skip', 0);
    params = params.append('count', 24);
    if (isDevMode()) {
      return this.http.get<any>(`${API_URLS.LOCAL}${url}`, { params });
    } else {
      return this.http.get<any>(url);
    }
  }
  removeFromFav(vehicleDetail: any) {
    let vehicles = [];
    // const options = {
    //   body : {
    //     vin: vehicleDetail.Vin
    //   }
    // };
    const url = isDevMode()
      ? `${API_URLS.LOCAL}${API_URLS.Remove_Fav_API_URL}`
      : `${API_URLS.Remove_Fav_API_URL}`;
    this.http.post<any>(`${url}`, { vin: vehicleDetail.Vin }).subscribe(
      (response) => {
        if (response.Success) {
          this.favVehicleDetails.subscribe((val) => {
            vehicles = val.filter(
              (vehiclesData) => vehiclesData.Vin !== vehicleDetail.Vin
            );
          });
          this.favVehicleDetails.next(vehicles);
          this._toastService.remove().subscribe((e) => {
            this.formInfoService.favoriteRemovalUndo();
            this.addToFav(vehicleDetail);
          });
          // update cookie
          // this._cookieService.put('FavoritesCount', vehicles.length.toString());
        } else {
          console.log(response);
          this._toastService.error();
        }
      },
      (err) => {
        console.log(err);
        this._toastService.error();
      }
    );
  }

  addToFav(vehicle: any) {
    //Save_Fav_API_URL
    let vehicles = [];
    const url = isDevMode()
      ? `${API_URLS.LOCAL}${API_URLS.Save_Fav_API_URL}`
      : `${API_URLS.Save_Fav_API_URL}`;
    this.http.post<any>(`${url}`, { vin: vehicle.Vin }).subscribe(
      (response) => {
        if (response.Success) {
          this.favVehicleDetails.subscribe((val) => {
            vehicles = val;
          });
          const index = vehicle.index;
          vehicles.splice(index, 0, vehicle);

          this.favVehicleDetails.next(vehicles);
          this._toastService.save();
        } else {
          this._toastService.error();
        }
      },
      (err) => {
        this._toastService.error();
      }
    );
  }
}
